'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');
var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);
var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  ', '\n  ', '\n  ', '\n'], ['\n  ', '\n  ', '\n  ', '\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _View = require('../View');
var _View2 = _interopRequireDefault(_View);
var _flex = require('../../../behaviors/flex');
var _flex2 = _interopRequireDefault(_flex);
var _spacings = require('../../../behaviors/spacings');
var _spacings2 = _interopRequireDefault(_spacings);
var _colors = require('../../../behaviors/colors');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var flexContainer = (0, _styledComponents2.default)(_View2.default)(_templateObject, _flex2.default, _spacings2.default, _colors.withBackgroundColor);
flexContainer.displayName = 'Flex';
exports.default = flexContainer;